import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';
import { confirmAlert } from 'react-confirm-alert';
import { encrypt } from '../../../services/crypto';
import { useMessageBox } from '../../../context/MessageBox'

import axios from 'axios';

import { getPermissions, TOKEN_USER } from '../../../services/auth';

import { dddTel, dataAtualFormatada, slugify } from '../../../utils/functions';

import api from '../../../services/api';

import EditRender from './EditRender';

function Edit({ id }) {
  const { setMessageData } = useMessageBox();
  const [getLoading, setLoading] = useState(true);
  const [inputs, setInputs] = useState({});
  const [colaboradorLoginId, setColaboradorLoginId] = useState(0)
  const [getEstados, setEstados] = useState([]);
  const [getMunicipios, setMunicipios] = useState([]);
  const [getJornadas, setJornadas] = useState([]);
  const [getPerfis, setPerfis] = useState([]);
  const [getErros, setErros] = useState([]);
  const [inputsBlocked, setInputsBlocked] = useState([]);
  const [getLastCep, setLastCep] = useState('');

  const history = useHistory();

  const findCep = async (cep) => {
    cep = cep.replace('-', '').replace('.', '');
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
      const { logradouro, bairro, ibge } = response.data;

      if (logradouro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'logradouro']);
      }
      if (bairro.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'bairro']);
      }
      if (ibge.length) {
        setInputsBlocked((inputsBlocked) => [...inputsBlocked, 'estado', 'municipio']);
        const responseMunicipio = await api.get(`Municipios/ConsultarIBGEId?id=${ibge}`);
        const { estadoId, municipioId } = responseMunicipio.data.resposta[0];
        setInputs({ ...inputs, logradouro, bairro, estadoId, municipioId });

        const listFields = ['Cep', 'Logradouro', 'Bairro', 'EstadoId', 'MunicipioId'];

        const newErros = getErros.filter(function (item) {
          return listFields.includes(item);
        });

        setErros(newErros);

        return false;
      }

      setInputs({ ...inputs, logradouro, bairro });
    } catch (err) {
      console.log(err);
      setInputsBlocked([]);
    }
  };

  useEffect(() => {
    if (getLastCep.length) {
      findCep(getLastCep);
    }
  }, [getLastCep]);

  const getColab = async () => {
    try {
      const response = await api.get(`Colaboradores/ConsultarId?id=${id}`);
      const colabInputs = response.data.resposta;
      setInputs({
        ...colabInputs,
        senha: '',
        telefone1: colabInputs.telefone1 ? `${colabInputs.ddd1} ${colabInputs.telefone1}` : null,
        telefone2: colabInputs.telefone2 ? `${colabInputs.ddd2} ${colabInputs.telefone2}` : null,
      });

      // if (colabInputs.status === 'Pendente' && !colabInputs.login) {
      const searchProfiles = await api.get('Perfis/Consultar?status=Ativo');
      setPerfis(searchProfiles.data.resposta);
      

      setColaboradorLoginId(colabInputs.loginId)

      const searchStates = await api.get('Estados/Consultar?status=Ativo');
      const searchJornadas = await api.get('JornadasTrabalhos/Consultar?status=Ativo');
      setEstados(searchStates.data.resposta);
      setJornadas(searchJornadas.data.resposta);
    } catch (err) {
      toast.error('Não foi possível obter os dados do colaborador!');
    }
    setLoading(false);
  };

  const getAllMunicipios = async (estadoid = null) => {
    try {
      const findByEstado = !estadoid ? inputs.estadoId : estadoid;
      const searchCities = await api.get(
        `Municipios/ConsultarEstadoId?id=${findByEstado}&status=Ativo`,
      );
      setMunicipios(searchCities.data.resposta);
      setInputs({ ...inputs, municipioId: inputs.municipioId });
    } catch (err) {
      toast.error('Falha ao consultar a lista de municípios');
    }
  };

  useEffect(() => {
    const permissions = getPermissions({ moduloId: 1344, permissao: 'Alterar' });
    if (permissions) {
      getColab();
    } else {
      history.push('/app');
    }
  }, []);

  useEffect(() => {
    if (inputs.estadoId) {
      getAllMunicipios();
    }
  }, [inputs.estadoId]);

  const handleInputChange = (event, value) => {
    event.persist();
    if (event.target.value === 'AjudaDeCusto') {
      confirmAlert({
        title: 'Informação',
        message:
          'Obrigatório colher assinatura no termo de Opção de Desistência do Vale Transporte',
        buttons: [
          {
            label: 'Ok',
          },
        ],
      });
    }
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: value || slugify(event.target.value),
    }));
  };

  const handleInputCheckboxChange = (event, value) => {
    event.persist();
    setInputs((inputs) => ({
      ...inputs,
      [event.target.name]: value,
    }));
  };

  const obrigarTrocaSenha = async () => {
    setLoading(true)
    try {
      const response = await api.post(`Logins/ObrigarTrocarSenha?loginId=${colaboradorLoginId}`)
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Troca de senha feita com sucesso');
      } else {
        toast.error('Não foi possivel obrigar a troca de senha');
      }
    } catch(error) {
      toast.error('Não foi possivel obrigar a troca de senha');
    } finally {
      setLoading()
    }
  }

  const liberarBloqueiSenha = async () => {
    setLoading(true)
    try {
      const response = await api.post(`Logins/LiberarBloqueioSenha?loginId=${colaboradorLoginId}`)
      setMessageData(response?.data?.complemento?.mensagensBox);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Bloquei Realizado com sucesso');
      } else {
        toast.error('Não foi possivel bloquear a senha');
      }
    } catch(error) {
      toast.error('Não foi possivel bloquear a senha');
    } finally {
      setLoading()
    }
  }

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();

      setLoading(true);
      try {
        // deletando os inputs que não vao pra rota de put

        const datesForStatus = {};

        if (inputs.status === 'Demitido') {
          datesForStatus.dataDemissao = inputs.dataDemissao
            ? dataAtualFormatada(inputs.dataDemissao)
            : null;
          inputs.dataAfastamentoFinal = null;
          inputs.dataAfastamentoInicial = null;
        } else if (inputs.status === 'Afastado') {
          inputs.dataDemissao = null;
          datesForStatus.dataAfastamentoInicial = inputs.dataAfastamentoInicial
            ? dataAtualFormatada(inputs.dataAfastamentoInicial)
            : null;
          datesForStatus.dataAfastamentoFinal = inputs.dataAfastamentoFinal
            ? dataAtualFormatada(inputs.dataAfastamentoFinal)
            : null;
        } else {
          inputs.dataDemissao = null;
          inputs.dataAfastamentoFinal = null;
          inputs.dataAfastamentoInicial = null;
        }

        const response = await api.put('Colaboradores', {
          ...inputs,
          ...datesForStatus,
          senha: encrypt(inputs.senha),
          dataRegistro: undefined,
          colaboradorId: parseInt(id),
          numero: inputs.numero && parseInt(inputs.numero),
          estadoId: inputs.estadoId && parseInt(inputs.estadoId),
          municipioId: inputs.municipioId && parseInt(inputs.municipioId),
          ctpsNumero: inputs.ctpsNumero && parseInt(inputs.ctpsNumero),
          qtdFilhosMenor14Anos:
            inputs.qtdFilhosMenor14Anos && parseInt(inputs.qtdFilhosMenor14Anos),
          jornadaTrabalhoId: inputs.jornadaTrabalhoId && parseInt(inputs.jornadaTrabalhoId),
          perfilId: inputs.perfilId && parseInt(inputs.perfilId),
          ddd1: inputs.telefone1 && dddTel(inputs.telefone1, 'ddd'),
          ddd2: inputs.telefone2 && dddTel(inputs.telefone2, 'ddd'),
          telefone1: inputs.telefone1 && dddTel(inputs.telefone1),
          telefone2: inputs.telefone2 && dddTel(inputs.telefone2),
          dataAdmissao: inputs.dataAdmissao && dataAtualFormatada(inputs.dataAdmissao),
          dataNascimento: inputs.dataNascimento && dataAtualFormatada(inputs.dataNascimento),
          valorSalario: inputs.valorSalario ? inputs.valorSalario : 0,
        });
        if (response.data.status !== 'Inconsistencia') {
          setInputs({
            ...inputs,
            loginId: response.data.resposta.loginId,
            dataAtualizacao: response.data.resposta.dataAtualizacao,
          });

          toast.success('Colaborador alterado com sucesso!');
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = [];

            response.data.resposta.map((resposta) => {
              errosArray.push(resposta.key);
              toast.error(resposta.key + ' - ' + resposta.message);
              return null;
            });
            setErros(errosArray);
          } else {
            toast.error('Não foi possível alterar o colaborador!');
          }
        }
      } catch (err) {
        toast.error('Não foi possível alterar o colaborador!');
      }
      setLoading(false);
    }
  };

  return (
    <EditRender
      inputs={inputs}
      handleInputChange={handleInputChange}
      handleInputCheckboxChange={handleInputCheckboxChange}
      getLoading={getLoading}
      getEstados={getEstados}
      getMunicipios={getMunicipios}
      getJornadas={getJornadas}
      onSubmit={handleSubmit}
      getErros={getErros}
      setErros={setErros}
      setLastCep={setLastCep}
      getLastCep={getLastCep}
      inputsBlocked={inputsBlocked}
      getPerfis={getPerfis}
      obrigarTrocaSenha={obrigarTrocaSenha}
      liberarBloqueiSenha={liberarBloqueiSenha}
    />
  );
}

export default Edit;
